// extracted by mini-css-extract-plugin
export default {"Section":"FAQ_Section__gwlO0","Header":"FAQ_Header__JqrHX"};